module.exports = __webpack_public_path__ + "static/media/Notification-HolidayShipmentDelay-Push-Preview.66b17c86.png";